'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { shallow } from 'zustand/shallow';

import { useDialog } from 'src/hooks/useDialog';
import { modalStore } from 'src/stores/modalStore';

export const HeaderMenuMobile: FC<PropsWithChildren> = ({ children }) => {
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  const { activeModal, closeModal } = modalStore(
    (state) => ({ activeModal: state.activeModal, closeModal: state.closeModal }),
    shallow,
  );

  const { openDialog, closeDialog } = useDialog({ dialogRef, onCloseModal: () => closeModal('mobileMenu') });

  // Handle opening and closing the popover
  useEffect(() => {
    if (activeModal === 'mobileMenu') {
      openDialog();
    } else {
      closeDialog();
    }
  }, [activeModal, openDialog, closeDialog]);

  return (
    <dialog
      ref={dialogRef}
      className={clsx(
        'group/dialog fixed top-0 left-0 z-modal max-h-dvh w-full max-w-full bg-transparent transition-opacity duration-200',
        // Backdrop styles
        'backdrop:bg-for-neu-scr backdrop:backdrop-saturate-50 backdrop:duration-400',
        // Starting styles
        'starting:backdrop:opacity-0 starting:open:opacity-0',
      )}
      data-testid="HeaderMenuMobile"
    >
      <div className="fixed top-0 left-0 h-lvh w-full bg-bac-tie1 md:bg-transparent">{children}</div>
    </dialog>
  );
};
